module.exports = __webpack_public_path__ + "static/img/supply.55890345.svg";